import { FC } from 'react';
import { useSeoBlockContext } from '../hooks';
import { SeoBlockLink } from './SeoBlockLink';
import seoBlockLinkList from '../assets/seo-block-link-list.module.scss';

const SeoBlockLinkList: FC = () => {
  const { linkList } = useSeoBlockContext();

  if (!linkList || linkList.length === 0) {
    return null;
  }

  const categoryElementList = linkList.map((link) => (
    <SeoBlockLink key={link.link.to} link={link} />
  ));

  return (
    <div className={seoBlockLinkList.seoBlockLinkList}>
      {categoryElementList}
    </div>
  );
};

export { SeoBlockLinkList };
